export default "__VITE_PUBLIC_ASSET__d8367b8b__"